const r = {
  default: "primary",
  primary: "primary",
  destructive: "error",
  info: "primary",
  warning: "primary",
  success: "primary"
}, i = {
  default: "secondary",
  destructive: "error",
  primary: "primary",
  info: "info",
  warning: "warning",
  success: "success"
};
export {
  r as STATE_TO_BUTTON_COLOR_MAPPING,
  i as STATE_TO_CHIP_COLOR_MAPPING
};
//# sourceMappingURL=constants8.mjs.map
